/**
 * Reads branding configuration from the React Query cache without triggering a fetch.
 *
 * Useful for pages like checkout that need to detect whether branding was
 * loaded by a previous page (e.g., event or membership page) and respond
 * instantly — no waffle flag check, no API call, no flash.
 */
import { useQueryClient } from "react-query";
import type { BrandingConfigSerializer } from "../data/types";
import { getBrandingQueryKey } from "../utils/ssr-branding-utils";

export function useCachedBrandingConfig():
  | BrandingConfigSerializer
  | undefined {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<BrandingConfigSerializer>(
    getBrandingQueryKey()
  );
}
